import React from "react";
import { DocMap, DocProps } from "../../Language";
import { InstructionOfBestExecutionSV as SV } from "./InstructionOfBestExecutionSV";
import { InstructionOfBestExecutionEN as EN } from "./InstructionOfBestExecutionEN";
import "../../Documents.css";

const docsMap: DocMap = { SV, EN };

export const InstructionOfBestExecution: React.FC<DocProps> = props =>
  React.createElement(docsMap[props.language], null);